import { SET_RFP_WRITERS, SET_RFP_ANSWER_PANEL_WIDTH_PCT } from '../constants/rfpConstants'

const initialState = {
  writers: [],
  panelWidthPct: 0.3
}

export default function rfpReducer(state = initialState, action) {
  switch (action.type) {
    case SET_RFP_WRITERS:
      return { ...state, writers: action.payload }
    case SET_RFP_ANSWER_PANEL_WIDTH_PCT:
      return { ...state, panelWidthPct: action.payload }
    default:
      return state
  }
}
